import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { motion } from "framer-motion"
import Link from "next/link"

export default function Dropdown({ btnName, trigger }) {
  const [isOpen, toggleIsOpen] = useState(false);

  const toggleClickMenu = (e) => {
    e.stopPropagation()
    toggleIsOpen(!isOpen);
  };

  const subMenuAnimate = {
    enter: {
      opacity: 1,
      rotateX: 0,
      transition: {
        duration: 0.5
      },
      display: "block"
    },
    exit: {
      opacity: 0,
      rotateX: -15,
      transition: {
        duration: 0.5,
        delay: 0.3
      },
      transitionEnd: {
        display: "none"
      }
    }
  };

  return (
    <>
      <motion.div
        className="menu-item flex flex-col"
        onClick={toggleClickMenu}
      >
        <button
          className='flex justify-center items-center'>
          {btnName} <FontAwesomeIcon className='ml-1' icon={faAngleDown} />
        </button>
        <motion.div
          className="sub-menu"
          initial="exit"
          animate={isOpen ? "enter" : "exit"}
          variants={subMenuAnimate}
        >
          <div className="absolute bg-midnight w-full md:w-[225px] border border-almost-white flex flex-col">
            <Link href="/portfolio/artistas">
              <a className='py-2 px-3 hover:bg-white/25'>Artistas</a>
            </Link>
            <Link href="/portfolio/fotografia-autoral">
              <a className='py-2 px-3 hover:bg-white/25'>Fotografia Autoral</a>
            </Link>
            <Link href="/portfolio/retratos">
              <a className='py-2 px-3 hover:bg-white/25'>Retratos</a>
            </Link>
            <Link href="/portfolio/fotografia-corporativa/">
              <a className='py-2 px-3 hover:bg-white/25'>Fotografia Corporativa</a>
            </Link>
            <Link href="/portfolio/fotografia-documental/documental-familia">
              <a className='py-2 px-3 hover:bg-white/25'>Fotografia Documental</a>
            </Link>
          </div>
        </motion.div>
      </motion.div>
    </>
  )
}